import { Currency } from "../utils";
import { ErrorType } from "../components/modals/Error";
import { MessageType } from "../components/modals/Message";
import { Layout } from "./slices/layout";
import { BuyBonusType } from "./slices/buy-bonus";
import {
  BalanceType,
  FullHistoryRound,
  HistoryRound,
  MaxWin
} from "../commander/Types";

const state = {
  // contains the general information/details/ about the game and the user
  details: {
    loaded: false,
    frozen: false,
    gameName: "",
    rtp: { value: "", level: -1 },
    maxWin: MaxWin.Normal,
    serverVersion: "N/A",
    logo: true,
    balance: { value: "0.00", net: "0.00", type: "basic" as BalanceType },
    currency: { code: "USD", symbol: "$", position: "left" } as Currency,
    language: "en",
    visible: false,
    sound: { mute: true, level: 0 },
    turbo: false,
    slamStop: true,
    fullscreen: false,
    history: true,
    lobby: "",
    bank: "",
    accountUri: "",
    // the starting point of the timer, if 0 the timer is now shown
    dynamicPaytable: false,
    timer: null as number | null,
  },
  soundsOverlay: { visible: false },
  spinnerOverlay: { visible: false, size: 0, stroke: 0, style: {} },
  loadingScreen: { visible: true, progress: 0 },
  // contains information about the data from which the user can select something /like stake, autoplay etc./
  selectors: {
    stake: {
      value: 0.6,
      index: 2,
      possibleValues: [
        0.2, 0.4, 0.6, 0.8, 1, 1.4, 1.8, 2, 3, 4, 6, 8, 10, 14, 18, 20, 30, 40,
      ],
    },
    info: {
      value: "",
      possibleValues: [
        { value: "pays", text: "pays" },
        { value: "help", text: "help" },
        { value: "history", text: "history" },
      ],
    },
  },
  modals: {
    active: null,
    closing: false,
    backdrop: false, // controls the presence of the backdrop
  },
  autoplay: {
    active: false,
    value: 0,
    possibleValues: [10, 20, 30, 50, 70, 100],
    limit: {
      loss: {
        current: 0,
        value: 0,
        values: [10, 20, 30, 40, 50, 60, 80, 100],
        active: false,
      },
      // win: {},
      bonus: { active: true },
    },
  },
  history: {
    initialized: false, // TODO is this trully need it?
    loading: true,
    page: 1,
    openedRounds: [] as string[],
    rounds: {} as { [id: string]: HistoryRound | FullHistoryRound },
    error: null as any,
  },
  realityCheck: {
    visible: false,
    time: 0,
    historyURL: "",
  },
  // the freeRounds.cache is used to cache some state /like autoplay availability/ before activating the free rounds
  freeRounds: {
    active: false,
    amount: 0,
    stake: 0,
    seen: false,
    totalWin: 0,
    cache: null,
  },
  error: null as ErrorType | null,
  messages: { title: "", message: "", placeholderValues: [] } as MessageType,
  buttons: {
    stake: { available: true, disabled: true, hidden: false },
    autoplay: { available: true, disabled: true, hidden: false },
    spin: {
      available: true,
      disabled: true,
      hidden: false,
      // spin or stop
      type: "spin",
      locked: { time: 0, progress: 0, timestamp: 0 },
    },
    info: { available: true, disabled: true, hidden: false },
    sound: { available: true, disabled: true, hidden: false },
    fullscreen: { available: true, disabled: true, hidden: false },
    home: { available: true, disabled: true, hidden: false },
    bank: { available: true, disabled: true, hidden: false },
    account: { available: true, disabled: true, hidden: false },
    turbo: { available: true, disabled: true, hidden: false },
    buyBonus: { available: false, disabled: true, hidden: false },
  },
  layout: { name: "", width: 0, height: 0, pixelRatio: 1 } as Layout,
  theme: { colors: {}, alphas: {} } as any,
  animations: { sample: { history: [], oneShot: true } } as any,
  buyBonus: null as BuyBonusType | null,
  previousWin: 0,
};

export default state;
